import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../img/Document scan.gif"
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import Pagination from "../../Pagination";
import { CiSearch } from "react-icons/ci";
import SplitPane from "react-split-pane";

const SiteSubjectScreenFailedHistory = ({ onMouseDown, tableRef }) => {
  const [subjectScreenFailedHistory, setSubjectScreenFailedHistory] = useState([]);
  const [subjectScreenFailedHistoryCount, setSubjectScreenFailedHistoryCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectScreenFailedHistoryCount / itemsPerPage);

  const getStudySubjectScreenFailedHistoryData = async () => {
    setDataLoader(true);
    let data = await studySubjectManagementServices.getStudySubjectScreenFailedHistoryData(
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setSubjectScreenFailedHistory(data?.data || [])
    setSubjectScreenFailedHistoryCount(data?.count || 0)
    setDataLoader(false);
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Study Id",
      "Site Id",
      "Subject Id",
      "Subject Gender",
      "Screen Status",
      "Reason",
      "Activity by",
      "Activity Date | Time",
    ];
    const rows = data.map((row, index) => [
      index + 1,
      row.studyName || "",
      row.siteName || "",
      row.subjectName || "",
      row.subjectGender || "",
      "Screen Failed",
      row.reason || "",
      row.activityByName || "",
      row?.createdDT
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Subject_Screen_Failed_History.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (!data || !data.length) return;
    const excelData = data.map((row, index) => ({
      "Sr.": index + 1,
      "Study Id": row.studyName,
      "Site Id": row.siteName,
      "Subject Id": row.subjectName,
      "Subject Gender": row.subjectGender,
      "Screen Status": "Screen Failed",
      "reason": row.reason,
      "Activity By": row.activityByName,
      "Activity Date | Time": row?.createdDT,
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Screen Failed History");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "subject_status.xlsx");
  };

  useEffect(() => {
    getStudySubjectScreenFailedHistoryData();
  }, [searchData, pageNumber, itemsPerPage]);

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {subjectScreenFailedHistoryCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <div className="gap-1 hstack">
            <button
              onClick={() => downloadCSV(subjectScreenFailedHistory)}
              className={`updateProfile`}
            >
              Download CSV
            </button>
            <button
              onClick={() => downloadExcel(subjectScreenFailedHistory)}
              className={`updateProfile`}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {dataLoader ? (
          <PageLoader/>
        ) : subjectScreenFailedHistoryCount === 0 ? (
          <NoDataFoundTable MSG={"Data Not Found!"} />
        ) : subjectScreenFailedHistory?.length === 0 ? (
          <NoDataFoundTable MSG={"Search Data Not Found!"} />
        ) : (
          <>
          <div className="overflow-auto">
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    className="text-center"
                    style={{ width: 45 }}
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Study Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Site Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Subject Gender</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Screen Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Reason</th>
                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Activity By</th>
                  <th onMouseDown={(e) => onMouseDown(e, 8)}>Activity Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {(subjectScreenFailedHistory || []).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="text-center">
                      {rowIndex + 1}
                    </td>
                    <td>{row?.studyName}</td>
                    <td>{row?.siteName}</td>
                    <td>{row?.subjectName}</td>
                    <td>{row?.subjectGender}</td>
                    <td className="text-danger fw-bold">Screen Failed</td>
                    <td>{row?.reason}</td>
                    <td>{row?.activityByName}</td>
                    <td>{row?.createdDT}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={subjectScreenFailedHistoryCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )
        }
      </SplitPane>
    </>
  );
};

export default SiteSubjectScreenFailedHistory;